import Container from "~/components/Container";
import Page from "~/components/Page";
import Section from "~/components/Section";
import BuyNowForm from "~/components/form/BuyNowForm";

export default function ClassPassPage() {

    return (
        <Page
            metaTitle="Buy a Yoga Class Pass"
            metaDescription="Purchase your Graceful Space Yoga class pass to book Vinyasa flow sessions in Catshill, Bromsgrove. Simple, secure checkout — £10 per class.">
            <Section>
                <Container>
                    <h1>Class Pass</h1>
                    <p>Welcome! We're so glad you're joining us on the mat.</p>
                    <br/>
                    <p>
                        Once you've purchased a class pass, you’ll be able to choose the date you’d like to attend.
                        Please note that all class pass purchases are non-refundable. However, we understand that life
                        happens — if you need to cancel your booking, you can do so up to 12 hours before the class and
                        your pass will be returned to your account for future use.
                    </p>
                    <br/>
                    <p>
                        Cancellations made less than 12 hours before the scheduled class will result in the pass being
                        marked as used. Thank you for your understanding and support!
                    </p>
                    <hr/>
                    <div>
                        <BuyNowForm/>
                    </div>
                </Container>
            </Section>
        </Page>
    )
}